export const DOCTOR_SELECTION_VIEW = 'DOCTOR_SELECTION_VIEW';
export const DOCTOR_SELECTION = 'DOCTOR_SELECTION';
export const DOCTOR_SELECTION_BACK = 'DOCTOR_SELECTION_BACK';
export const generateDoctorSelectionFocusKey = (index: number) =>
  `${DOCTOR_SELECTION}_${index}`;
export const DOCTOR_SELECTION_QUICK = 'DOCTOR_SELECTION_QUICK';
